import React from 'react';
import styled, { css } from 'styled-components';
import Markdown, { InlineAnchor } from '~/components/molecule/Markdown';
import { Heading5, Heading4, Variant } from '~/components/atom/Typography';

export type Props = {
  value: string;
  $dimmed?: boolean;
};

const components = {
  h1: props => <Heading4 variant={Variant.primary} {...props} />,
  h2: props => <Heading5 variant={Variant.primary} {...props} />,
  a: props => (
    <InlineAnchor {...props} target="_blank" rel="noreferrer noopener" />
  ),
};

const CustomMarkdown: React.FCC<Props> = ({ value, dataTestId, $dimmed }) => (
  <Container $dimmed={$dimmed}>
    <Markdown
      dataTestId={dataTestId}
      value={value}
      options={{ remarkReactComponents: components }}
    />
  </Container>
);

const Container = styled.div<{ $dimmed?: boolean }>(
  ({ $dimmed }) => css`
    ${$dimmed &&
    css`
      opacity: 0.6;
    `}
  `,
);

export default CustomMarkdown;
